import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { SiteShell } from './components/SiteShell'
import { HomePage } from './pages/HomePage'
import { PlatformPage } from './pages/PlatformPage'
import { ResearchPage } from './pages/ResearchPage'
import { FrameworkPage } from './pages/FrameworkPage'
import { CrosswalkPage } from './pages/CrosswalkPage'
import { CompanyPage } from './pages/CompanyPage'
import { ContactPage } from './pages/ContactPage'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])
  return null
}

export default function App() {
  return (
    <SiteShell>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<CompanyPage />} />
        <Route path="/conseqra" element={<HomePage />} />
        <Route path="/platform" element={<PlatformPage />} />
        <Route path="/research" element={<ResearchPage />} />
        <Route path="/research/semantic-security" element={<Navigate to="/research/semantic-security/framework" replace />} />
        <Route path="/research/semantic-security/framework" element={<FrameworkPage />} />
        <Route path="/research/semantic-security/framework/crosswalk" element={<CrosswalkPage />} />
        <Route path="/research/framework" element={<Navigate to="/research/semantic-security/framework" replace />} />
        <Route path="/research/crosswalk" element={<Navigate to="/research/semantic-security/framework/crosswalk" replace />} />
        <Route path="/research/publications" element={<Navigate to="/research" replace />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </SiteShell>
  )
}
